function mapUserType(user_type) {
    let userType = "";

    if (Array.isArray(user_type)) {
        for (let i = 0; i < user_type.length; i++) {
            userType += ` ${user_type[i]} - `;
        }
    } else userType = user_type === "" ? "N/A" : user_type;
    return userType;
}

function paresRows(props, quesitons_cols, users) {
    let list = [];
    for (let i = 0; i < users.length; i++) {
        let vals = {
            registration_date: new Date(
                users[i].registration_date
            ).toLocaleDateString(),
            fullname: users[i].hasOwnProperty("firstname") && users[i].firstname !== "" ?
                users[i].firstname + " " + users[i].familyname : "Name Undefined",
            confirmed: users[i].confirmed ? "Yes" : "No",
            phone: users[i].hasOwnProperty("phone") && users[i].phone !== "" ?
                users[i].phone : "N/A",
            email: users[i].hasOwnProperty("email") ? users[i].email : "N/A",
            attended: users[i].attended ? "Yes" : "No",
            walkin: users[i].walkin ? "Yes" : "No",
            /*waitlist: users[i].waitlist ? "Yes" : "No",*/
            rejected: users[i].hasOwnProperty("rejected") ? ( users[i].rejected ? "Yes" : "No") :"No",
            canceled: users[i].canceled ? "Yes" : "No",
           
            beneficiary_type: users[i].hasOwnProperty("user_type") ?
                mapUserType(users[i].user_type) : "N/A",
            business_sector: users[i].hasOwnProperty("sector") || users[i].sector === "" ?
                users[i].sector : "N/A",
            region: users[i].hasOwnProperty("region") ? users[i].region : "N/A",
            id: users[i].id,
        };

        if (props.confirmType === "filter" || Object.keys(props.form).length > 0) {
            //loop in the answers
            let quesitons_rows = [];
            for (let q of quesitons_cols) {
                if (!users[i].hasOwnProperty("form_response"))
                    quesitons_rows[q.key] = "Not answered";
                else if (!users[i].form_response.hasOwnProperty(q.text))
                    quesitons_rows[q.key] = "Not answered";
                else if (q.type === "mcq")
                    quesitons_rows[q.key] = users[i].form_response[q.text];
                else if (q.type === "cbq") {
                    let option_selected = "";
                    let cbqs = users[i].form_response[q.text];
                    for (let j in cbqs) {
                        if (cbqs[j] === true) {
                            option_selected += j + " - ";
                        }
                    }
                    option_selected = option_selected.trim();
                    quesitons_rows[q.key] = option_selected;
                } else if (q.type === "long_text" || q.type === "text") {
                    quesitons_rows[q.key] = users[i].form_response[q.text]
                        .replace(/,/g, "-")
                        .replace(/\n/g, " ");
                }
            }

            //append questinos rows to list
          
            var merged = {};
            for (let key in vals) merged[key] = vals[key];
            for (let key in quesitons_rows) merged[key] = quesitons_rows[key];


            list.push(merged);
        } else {
            list.push(vals);
        }
    }

    return list;
};



export default paresRows;